/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Pose_Invalid11Inputs */

const en_us2_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your whole body couldn't be found in the expected position. Be the only person in the photo, about 2 m from the phone, framed head to feet, with both feet on the floor.`)
};

const pt_br2_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para encontrar o corpo inteiro na posição esperada. Fique sozinho na foto, a uns 2 m do celular, com o corpo enquadrado da cabeça aos pés e os dois pés no chão.`)
};

const es_419_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró tu cuerpo entero en la posición esperada. Sé la única persona en la foto, a unos 2 m del teléfono, encuadrada de la cabeza a los pies, con los dos pies en el suelo.`)
};

const pt_pt2_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível encontrar o corpo inteiro na posição esperada. Fica sozinho na foto, a uns 2 m do telemóvel, com o corpo enquadrado da cabeça aos pés e os dois pés no chão.`)
};

const fr_fr2_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de trouver tout ton corps dans la position attendue. Personne d'autre que toi sur la photo, à environ 2 m du téléphone, le corps cadré de la tête aux pieds, les deux pieds au sol.`)
};

const de_de2_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein ganzer Körper wurde nicht in der erwarteten Position gefunden. Sei allein auf dem Foto, etwa 2 m vom Handy entfernt, von Kopf bis Fuß im Bild, mit beiden Füßen auf dem Boden.`)
};

const it_it2_body_assessment_error_pose_invalid11 = /** @type {(inputs: Body_Assessment_Error_Pose_Invalid11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile trovare tutto il corpo nella posizione prevista. Devi essere l'unica persona nella foto, a circa 2 m dal telefono, inquadratura dalla testa ai piedi ed entrambi i piedi a terra.`)
};

/**
* | output |
* | --- |
* | "Your whole body couldn't be found in the expected position. Be the only person in the photo, about 2 m from the phone, framed head to feet, with both feet on..." |
*
* @param {Body_Assessment_Error_Pose_Invalid11Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_pose_invalid11 = /** @type {((inputs?: Body_Assessment_Error_Pose_Invalid11Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Pose_Invalid11Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_pose_invalid11(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_pose_invalid11(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_pose_invalid11(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_pose_invalid11(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_pose_invalid11(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_pose_invalid11(inputs)
	return en_us2_body_assessment_error_pose_invalid11(inputs)
});
export { body_assessment_error_pose_invalid11 as "body-assessment.error.POSE_INVALID" }